import { Group, Text } from '@mantine/core';
import { memo } from 'react';

import { TsrButtonLink } from '@ui';

interface FieldNameCellProps {
  rowId: string;
  crop: string;
  value: string;
  disabled:boolean;
}

export const FieldNameCell = memo(
  ({ rowId, crop, value, disabled }: FieldNameCellProps) => {
    return (
      <Group gap={0}>
        <TsrButtonLink
          disabled={disabled}
          fullWidth
          justify="start"
          maw={250}
          ml="calc(var(--button-padding-x-compact-md) * -1)"
          params={{ formId: rowId, crop }}
          size="compact-md"
          td="underline"
          to="/interculture/$crop/$formId/result/maps"
          tt="capitalize"
          variant="subtle"
        >
          <Text span truncate="end">
            {value}
          </Text>
        </TsrButtonLink>
      </Group>
    );
  },
);
